<template lang="pug">
v-tooltip(
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(#activator="activator")
    div(v-on="activator.on" v-bind="activator.attrs" :class="activatorClass" ref="activator")
      slot(v-bind="activator")
  slot(name="reason")
    span(v-if="text") {{ text }}

</template>

<script>
import { VTooltip } from 'vuetify/lib';

export default {
  components:  { VTooltip },
  props: {
    text: { type: [String, Number], default: '' },
    activatorClass: { type: [String, Array], default: 'd-block-inline fit-content-height fit-content-width' },
    contentClass: { type: String, default: '' },
    top: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      const {
        contentClass,
        right,
        left,
        top,
        bottom,
        $attrs,
      } = this;
      const hasOrientation = [right, left, top, bottom].some(Boolean);
      return {
        contentClass: [
          'ui-design ui-box-shadow pa-4 ui-bright ui-neutral--text rounded-12 ui-body-1 opacity-100',
          contentClass,
        ].join(' '),
        'max-width': 250,
        right,
        left,
        top,
        bottom,
        ...hasOrientation ? {} : { top: true },
        ...$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
